import React from "react";

import PokerBackground from "@pages/casino/assets/backgrounds/poker-bg.png";

import { BackgroundCardContainer } from "./elements";

const BackgroundCard = ({ image, children, title, providerTitle, ...props }) => {
	return (
		<BackgroundCardContainer
			image={image || PokerBackground}
			{...props}>
			<div className="title-container">
				{children}

				{(providerTitle || title) && (
					<span>
						{providerTitle}
						{title}
					</span>
				)}
			</div>
		</BackgroundCardContainer>
	);
};

export default BackgroundCard;
